/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CheckFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.5 13.4639L8.25879 10.8496L6.74121 12.1504L9.74121 15.6504L9.81641 15.7295C10.0007 15.9022 10.2447 16 10.5 16C10.7919 16 11.0688 15.872 11.2588 15.6504L17.2588 8.65039L15.7412 7.34961L10.5 13.4639Z'
      fill='currentColor'
    />
  </React.Fragment>
)
